import React, { Fragment, useState } from "react";
import Overlay from "components/Overlay";
import { useFormikContext } from "formik";
import { setEditorFocus } from "utils/builder";
import { getFocusForContext } from "utils/hooks/focus";
import {
  VALIDATION_CHECKOUT_KEY_MAP,
  VALIDATION_CHECKOUT_KEY_TITLE_MAP
} from "constants/validation";
import classnames from "classnames";

const DEFAULT_CLASSES = {
  container: "flex flex-row items-center bg-danger-05 pointer w-100",
  notice: "fw5 f5 pv2 ph3",
  content: "pa3",
  title: "f3 fw6 pt3 pb4"
};

const DEFAULT_NOUN = "page";
const LINK_COPY_DEFAULT = "Learn more";

const ValidationsBar = ({
  context: parentContext,
  validations,
  customClasses,
  noun,
  onFocus,
  values,
  setValues
}) => {
  const ctxNoun = noun || DEFAULT_NOUN;

  const classes = { ...DEFAULT_CLASSES, ...customClasses };
  const [showOverlay, setShowOverlay] = useState(false);
  const { values: localValues, setValues: localSetValues } = useFormikContext();
  const ctxValues = values || localValues;
  const ctxSetValues = setValues || localSetValues;

  const entityUuid = validations.uuid;

  let errorCount = 0;
  let sections = [];
  for (const context in validations) {
    const isValidKey = VALIDATION_CHECKOUT_KEY_MAP[context];
    if (isValidKey) {
      const group = validations[context];
      if (group && Array.isArray(group)) {
        const nodes = [];
        for (let groupIx = 0; groupIx < group.length; groupIx++) {
          const item = group[groupIx];
          if (item) {
            const { errors, index, meta } = item;
            if (Array.isArray(errors)) {
              for (let errorIx = 0; errorIx < item.errors.length; errorIx++) {
                const error = item.errors[errorIx];
                const ctxLinkCopy = error.linkCopy || LINK_COPY_DEFAULT;
                nodes.push(
                  <li
                    className={classnames("w-100 ba hairline-1 br2", {
                      mt2: errorIx
                    })}
                  >
                    <div className="pa2">
                      <div className="f5 lh-copy">
                        {error.copy}
                        {error.url && (
                          <span>
                            <a
                              target="_blank"
                              style={{ paddingLeft: 4 }}
                              className="f5 link color-primary fw6 link__decoration--hover"
                              href={error.url}
                            >
                              {ctxLinkCopy}
                            </a>
                          </span>
                        )}
                      </div>
                    </div>
                    {entityUuid && context !== parentContext && (
                      <div className="bt hairline-1">
                        <div className="pa2">
                          <div
                            className="f6 fw6 link__decoration--hover color-primary pointer"
                            onClick={() => {
                              const focus = getFocusForContext({
                                context,
                                uuid: entityUuid,
                                activeIndex: index
                              });

                              setShowOverlay(false);
                              if (typeof onFocus === "function") {
                                onFocus();
                              }
                              setTimeout(() => {
                                focus &&
                                  setEditorFocus({
                                    values: ctxValues,
                                    setValues: ctxSetValues,
                                    focus
                                  })();
                              }, 0);
                            }}
                          >
                            Review checkout
                          </div>
                        </div>
                      </div>
                    )}
                  </li>
                );
              }
            }
          }
        }

        if (nodes.length) {
          sections.push(
            <div className="w-100" key={context}>
              <div className="f4 fw5 pb3">
                {VALIDATION_CHECKOUT_KEY_TITLE_MAP[context]}
              </div>
              <ul className="list ma0 pa0">{nodes}</ul>
            </div>
          );
        }

        group.forEach((item) => {
          if (item && Array.isArray(item.errors)) {
            errorCount += item.errors.length;
          }
        });
      }
    }
  }
  if (!errorCount) {
    return null;
  }

  const notice =
    errorCount > 1
      ? `Review ${errorCount} ${ctxNoun} errors.`
      : `Review ${errorCount} ${ctxNoun} error.`;

  return (
    <Fragment>
      <div className={classes.container} onClick={() => setShowOverlay(true)}>
        <div className={classes.notice}>{notice}</div>
      </div>
      {showOverlay && (
        <Overlay hideOverlay={() => setShowOverlay(false)}>
          <div className={classes.content}>
            <div className={classes.title}>Errors</div>
            {sections.map((section, sectionIx) => (
              <div key={sectionIx} className={sectionIx ? "pt3" : ""}>
                {section}
              </div>
            ))}
          </div>
        </Overlay>
      )}
    </Fragment>
  );
};

export default ValidationsBar;
